import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core'
import { EmailAddressTextFieldValidator } from '../../../validations/email-address-text-field-validator'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { } from '../../../validations/email-address-text-field-validator'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'


@Component({
    selector: 'eob',
    templateUrl: './explanation-of-benefits.component.html',
    styleUrls: ['explanation-of-benefits.component.scss']

})
export class ExplanationOfBenefitComponent implements OnInit {
    @Output() onEobOptionChange: EventEmitter<boolean> = new EventEmitter<boolean>()
    @Output() onEmailChange: EventEmitter<string> = new EventEmitter<string>()
    @Input() eobOption: string = ""
    @Input() email: string = ""
    emailAddressTextFieldValidator = new EmailAddressTextFieldValidator()
    emailLabel: string
    eobOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    enroll: EnrollmentViewModel = {} as EnrollmentViewModel
    @Input() EOBEmaildisabled: boolean

    ngOnInit() {
        this.emailLabel = 'Email Address (Required for Paperless)'
        this.enroll = this._enrollService.getEnrollmentViewModel()
        if (this.enroll.EOB != undefined) {
            this.eobOption = this.enroll.EOB
            this.email = this.enroll.APPEMAIL

            //this.eobOptionChanged(this.eobOption)
            this.emailChanged(this.email)
        }


    }

    constructor(private _enrollService: EnrollmentGateway) {
        this.eobOptions = [
            //{ value: 'EEOB', htmlLabel: 'Yes, I want to go paperless for all available and future documents' },
            //{ value: 'PEOB', htmlLabel: 'No, I want to receive all my documents in the mail' }
            { value: '3', htmlLabel: 'Yes, I want to go paperless for all available and future documents' },
            { value: 'N', htmlLabel: 'No, I want to receive all my documents in the mail' }
        ]


    }

    eobOptionChanged(option: boolean) {
        //this.eobOption = option
        console.log("papless val" + option )
        if (option === true)
            this.enroll.EOB = '3'
        else
            this.enroll.EOB = 'N'
       
        //if (option === 'EEOB') {
        //if (option === '3') {
        //    this.emailLabel = 'Email Address (Required for Paperless)'
        //} else {
        //    this.emailLabel = 'Email Address (Optional)'
        //}

        this.onEobOptionChange.emit(option)
    }

    emailChanged(option: string) {
        this.email = option
        this.onEmailChange.emit(option)
    }
}